const metaObjectsCards = JSON.parse(document.getElementById('metaobjects-dwcards-json').textContent);

(function() {
  if($('#btn-newsletter').length > 0)
  {
    $('#btn-newsletter').on('click', function (e) {
      e.preventDefault();
      $(".error_name").css("display", "none");
      $(".error_server").css("display", "none");
      var customerName = $.trim($("#contact_name").val());
      if(customerName == "")
      {
        $(".error_name").css("display", "block");
      }
      else{
        $('#btn-newsletter').addClass("loading");
        $('#btn-newsletter').attr('disabled','disabled');
        try {
          const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/newsletter.php', 
          {
            method: "POST",
            body: JSON.stringify({
              id: window.inspire_listings_cta.customer_id,
              name: customerName,
              lang: window.inspire_listings_cta.lang
            })
          });
          response.then(res => {
            return res.json();
          })
          .then(res => {
            $('#btn-newsletter').removeAttr('disabled');
            $('#btn-newsletter').removeClass("loading");
            if(res.status){
              window.location.href = window.location.href;
            }
            else{
              $(".error_server").css("display", "block");
            }
            
          });
        } catch (error) {
            console.log(error);
            $('#btn-newsletter').removeAttr('disabled');
            $('#btn-newsletter').removeClass("loading");
            $(".error_server").css("display", "block");
        }
      }
    });
  }
  
  if($(".cards-listing-container").length > 0)
  {
    try 
    {
      const response = fetch('https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/cards.php', 
      {
        method: "POST",
        body: JSON.stringify({
          customer_id: window.inspire_listings_cta.customer_id,
          lang: window.inspire_listings_cta.lang
        })
      });
      response.then(res => {
        return res.json();
      })
      .then(res => 
      {
        
        if(res.status){
          var arrCards = [];
          
          for (let i = 0; i < res.data.length; i++) 
          {
            var item = res.data[i];
            const card = metaObjectsCards.find((element) => parseInt(element.id) == parseInt(item.id));
            if(card != undefined)
            {
              var d = Date.parse(item.viewedAt);
              var nowDate = new Date();
              if((nowDate.getTime() - d) < (1000*60*60*24))
              {
                var im = card.image_en;
                if(window.inspire_listings_cta.lang == "pt-BR")
                  im = card.image_pt;
                arrCards.push( 
                {
                  image : im,
                  date: d,
                  dateText: (new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric" }))
                });
              }
            }
          }
          
          /* arrCards.sort(function(a, b) {
              return a.date - b.date;
          }); */

          /*const swiper = new Swiper('.cards-listing', {
            slidesPerView: 4,
            spaceBetween: 12,
            centeredSlides: false,
            loop: false,
            breakpoints: {
              320: {
                slidesPerView: 1.3,
                spaceBetween: 8,
                centeredSlides: false
              },
              640: {
                slidesPerView: 2.3,
                spaceBetween: 8,
                centeredSlides: true
              },
              768: {
                slidesPerView: 6.3,
                spaceBetween: 12,
                centeredSlides: false
              }
            },
            pagination: {
              el: '.item-listing-pagination',
              clickable: true,
            },
            touchRatio: 1,
            simulateTouch: true,
            grabCursor: true,
            speed: 400,
            preventClicks: true,
            preventClicksPropagation: true
          });*/
          
          //var html = ``;
          //html = html + `<div class="item-listing-container">`;
          
          for (let i = 0; i < arrCards.length; i++) {
              $(".cards-listing-container").append(`<div class="swiper-slide card"><img src="` + arrCards[i].image + `"><span>` + (i + 1) + `</span></div>`);
          }

          if(arrCards.length == 0)
          {
            $(".shuffle-again").removeClass("hidden");
          }
          //html = html + `</div>`;
          //$(".cards-listing").append(html);

          
        }
        else{
        }
        
      });
    } catch (error) {
        
    }
  }

  
})();
